import { trpc } from '@/shared/api/trpc';

export const useRemoveTask = () => {
  const utils = trpc.useUtils();
  return trpc.tasks.remove.useMutation({
    onSettled: () => {
      utils.tasks.list.invalidate();
      utils.tasks.flaggedCount.invalidate();
      utils.tasks.getNextActions.invalidate();
    },
  });
};
